import * as React from 'react';

import { Tooltip } from '@gitbook/spine-react';

import { useDateShortRelative } from './useDateShortRelative';

/**
 * Display a date as a short relative indicator (ex: "16hr", "2min")
 *
 * Useful links regarding the correct abbreviations:
 * https://www.aresearchguide.com/monthdayabb.html
 * https://www.quora.com/What-is-the-proper-way-to-abbreviate-the-word-day
 */
export const DateShortRelative = React.forwardRef(function DateShortRelativeWithRef(
    props: {
        value: Date | string;
        /**
         * Display only the date.
         * @default true
         */
        onlyDate?: boolean;
        className?: string;
        children?: React.ReactNode;
    },
    ref: React.ForwardedRef<HTMLTimeElement>
): React.ReactElement {
    const { value, onlyDate = true, ...rest } = props;
    const {
        date,
        value: humanPeriod,
        accessibilityValue,
        tooltip,
    } = useDateShortRelative(value, { onlyDate });

    return (
        <Tooltip label={tooltip}>
            <time ref={ref} dateTime={date.toISOString()} aria-label={accessibilityValue} {...rest}>
                {humanPeriod}
            </time>
        </Tooltip>
    );
});
